export default {
  Service: 'ui.page.Service',
  Plans: 'ui.page.Plans',
  'plans-show': 'ui.page.plans-show',
  'furniture-show': 'ui.page.furniture-show',
  'aperture-show': 'ui.page.aperture-show',
  'molding-show': 'ui.page.molding-show',
  'material-show': 'ui.page.material-show',
  'design-files': 'ui.page.design-files',
  'guard-create': 'ui.page.guard-create',
  'guard-show': 'ui.page.guard-show',
  'branding-show': 'ui.page.branding-show',
  DatasetSelectionPlans: 'ui.page.DatasetSelectionPlans',
  GetToWork: 'ui.page.GetToWork',
  'library-furniture-svg': 'ui.page.library-furniture-svg',
  'library-furniture-objects': 'ui.page.library-furniture-objects',
  'library-furniture-tags': 'ui.page.library-furniture-tags',
  'library-furniture-tag-categories': 'ui.page.library-furniture-tag-categories',
  'library-furniture-groups': 'ui.page.library-furniture-groups',
  'library-materials-objects': 'ui.page.library-materials-objects',
  'library-materials-tags': 'ui.page.library-materials-tags',
  'library-apertures-objects': 'ui.page.library-apertures-objects',
  'library-apertures-tags': 'ui.page.library-apertures-tags',
  'library-moldings-objects': 'ui.page.library-moldings-objects',
  'library-moldings-tags': 'ui.page.library-moldings-tags',
  'library-style-objects-create': 'ui.page.library-style-objects-create',
  'library-style-objects': 'ui.page.library-style-objects',
  'library-style': 'ui.page.library-style',
  'library-styles': 'ui.page.library-styles',
  'library-presets': 'ui.page.library-presets',
  'library-room-types': 'ui.page.library-room-types',
  'library-environments': 'ui.page.library-environments',
  'quality-checklists': 'ui.page.quality-checklists',
  'quality-guards': 'ui.page.quality-guards',
  'quality-issue-categories': 'ui.page.quality-issue-categories',
  'integrations-brandings': 'ui.page.integrations-brandings',
  'integrations-webhooks': 'ui.page.integrations-webhooks',
  'users-list': 'ui.page.users-list',
  'users-register': 'ui.page.users-register',
  ErrorPage: 'ui.page.ErrorPage',
  MattermostCallback: 'ui.page.MattermostCallback',
  Profile: 'ui.page.Profile',
  'crm-plans': 'ui.page.crm-plans',
  'crm-plans-database': 'ui.page.crm-plans-database',
  'crm-plans-show': 'ui.page.crm-plans-show',
  'crm-plans3d-show': 'ui.page.crm-plans3d-show',
  'crm-work-schedule': 'ui.page.crm-work-schedule',
  'crm-work-schedule-employee': 'crm.work_schedule.view',
  'crm-payroll': 'ui.page.crm-payroll',
  'crm-payroll-employees': 'ui.page.crm-payroll-employees',
  'crm-payroll-employee': 'ui.page.crm-payroll-employee',
  'crm-reviews': 'ui.page.crm-reviews',
  'crm-review-show': 'ui.page.crm-review-show',
  'crm-ninja-board': 'ui.page.crm-ninja-board',
  'crm-fix-show': 'ui.page.crm-fix-show',
  'crm-upload': 'ui.page.crm-upload',
  'crm-search': 'ui.page.crm-search',
  'crm-search-reference': 'ui.page.crm-search-reference',
  'crm-my-plans': 'ui.page.crm-my-plans',
  'crm-apartments': 'ui.page.crm-apartments',
  'crm-production-matrix': 'ui.page.crm-production-matrix',
  'crm-production-matrix-distribution': 'ui.page.crm-production-matrix-distribution',
  'crm-production-matrix-schedule': 'crm.work_schedule.view',
  'crm-apartment-style-revision-create': 'ui.page.crm-apartment-style-revision-create',
  'crm-apartments-id': 'ui.page.crm-apartments-id',
  'crm-apartments-plans-show': 'ui.page.crm-apartments-plans-show',
  'crm-apartments-plans-3d-show': 'ui.page.crm-apartments-plans-3d-show',
  'crm-statistic-particular-ninja': 'ui.page.crm-statistic-particular-ninja',
  'crm-cutting-plans': 'ui.page.crm-cutting-plans',
  'crm-cutting-plans-show': 'ui.page.crm-cutting-plans-show',
  'crm-customers': 'ui.page.crm-customers',
  'Batch-actions': 'ui.page.Batch-actions',
};
